// Components & Data Imports
import Header from '../layout/Header'
import Hero from '../layout/Hero'
import About from '../layout/About'
import Equipment from '../layout/Equipment'
import Photovoltaic from '../layout/Photovoltaic'
import Products from '../layout/Products'
import Contact from '../layout/Contact'
import Footer from '../layout/Footer'

const MainPage = () => {
  return (
    <>
      <main id='main-content'>
        <Header />
        <Hero />
        <About />
        <Equipment />
        <Photovoltaic />
        <Products />
        <Contact />
      </main>
      <Footer />
    </>
  )
}

export default MainPage
